import { GetterTree } from 'vuex'

import { RootState, ContributerState } from '@/types/store'

export const getters: GetterTree<ContributerState, RootState> = {
  contributers(state): ContributerState['contributers'] {
    return state.contributers
  },
  total(state): ContributerState['total'] {
    return state.total
  },
  isContributersLoading(state): ContributerState['isContributersLoading'] {
    return state.isContributersLoading
  },
}
